export const displayNone = 'none';



// WEBPACK FOOTER //
// ./src/scripts/constants/displayStyleConstants.js